// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","851":"component---src-templates-post-js"}[chunkId] + "-" + {"532":"7959e5b36f8ef1453af9","851":"3e0a3f71b7a14605871d"}[chunkId] + ".js";
};